import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { Button } from '../ui/button';
import HomeGalleryCard from './HomeGalleryCard';

const GallerySection = ({ galleryItems, heading, subheading }) => {
  return (
    <section id="gallery" className="py-20 bg-slate-900/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            {heading || 'Our Work'}
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto mb-8">
            {subheading || 'A showcase of our craftsmanship and attention to detail'}
          </p>
          <Link to="/gallery">
            <Button className="bg-red-600 hover:bg-red-700 text-white px-8 py-6 text-lg">
              View Full Gallery
              <ChevronRight className="w-5 h-5 ml-2" />
            </Button>
          </Link>
        </div>

        {/* Preview of first 3 items */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
          {galleryItems.slice(0, 3).map((item) => (
            <HomeGalleryCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default GallerySection;
